import React, { useMemo } from 'react';
import cn from 'classnames';
import { getQueryString, useRouter } from '@/Framework/Router';
import { TabLink } from '@/Framework/Router/Next/Link';
import LeagueCountLabel from '@/finsight/ui/components/league/LeagueTablePage/LeagueCountLabel';
import { TypeCompany } from '@/finsight/application/League/constants';

import tabsStyles from '@dealroadshow/uikit/core/styles/tabs.scss';
import styles from '@/finsight/ui/components/league/LeagueTablePage/leagueTablePage.scss';

interface ILeagueTableTab {
  path: string,
  title: string,
  typeCompany: TypeCompany,
  dataTest: string,
}

const LeagueTableTab = ({ path, title, typeCompany, dataTest }:ILeagueTableTab) => {
  const { query: { products, regions, q } } = useRouter();
  const search = { products, regions, q };
  const url = useMemo(
    () => `${ path }?${ getQueryString(search) }`,
    [products, regions, q],
  );

  return (
    <TabLink
      to={ url }
      className={ cn(tabsStyles.tab, styles.pageTab) }
      activeClassName={ tabsStyles.isTabActive }
      dataTest={ `${ dataTest }Tab` }
    >
      <span>{ title }</span>
      <LeagueCountLabel typeCompany={ typeCompany } />
    </TabLink>
  );
};

export default LeagueTableTab;
